let dateUtil = {}

dateUtil.daysOfWeek = [
  { text: 'Monday', value: 1 },
  { text: 'Tuesday', value: 2 },
  { text: 'Wednesday', value: 3 },
  { text: 'Thursday', value: 4 },
  { text: 'Friday', value: 5 },
  { text: 'Saturday', value: 6 },
  { text: 'Sunday', value: 7 }]

dateUtil.daysOfWeekDict = {
  1: { text: 'Monday', short: 'Mon', value: 1 },
  2: { text: 'Tuesday', short: 'Tue', value: 2 },
  3: { text: 'Wednesday', short: 'Wed', value: 3 },
  4: { text: 'Thursday', short: 'Thu', value: 4 },
  5: { text: 'Friday', short: 'Fri', value: 5 },
  6: { text: 'Saturday', short: 'Sat', value: 6 },
  7: { text: 'Sunday', short: 'Sun', value: 7 }
}

dateUtil.thirtyMinPeriodsDayInSeconds = [
  { text: '00:00', value: 0 * 30 * 60 },
  { text: '00:30', value: 1 * 30 * 60 },
  { text: '01:00', value: 2 * 30 * 60 },
  { text: '01:30', value: 3 * 30 * 60 },
  { text: '02:00', value: 4 * 30 * 60 },
  { text: '02:30', value: 5 * 30 * 60 },
  { text: '03:00', value: 6 * 30 * 60 },
  { text: '03:30', value: 7 * 30 * 60 },
  { text: '04:00', value: 8 * 30 * 60 },
  { text: '04:30', value: 9 * 30 * 60 },
  { text: '05:00', value: 10 * 30 * 60 },
  { text: '05:30', value: 11 * 30 * 60 },
  { text: '06:00', value: 12 * 30 * 60 },
  { text: '06:30', value: 13 * 30 * 60 },
  { text: '07:00', value: 14 * 30 * 60 },
  { text: '07:30', value: 15 * 30 * 60 },
  { text: '08:00', value: 16 * 30 * 60 },
  { text: '08:30', value: 17 * 30 * 60 },
  { text: '09:00', value: 18 * 30 * 60 },
  { text: '09:30', value: 19 * 30 * 60 },
  { text: '10:00', value: 20 * 30 * 60 },
  { text: '10:30', value: 21 * 30 * 60 },
  { text: '11:00', value: 22 * 30 * 60 },
  { text: '11:30', value: 23 * 30 * 60 },
  { text: '12:00', value: 24 * 30 * 60 },
  { text: '12:30', value: 25 * 30 * 60 },
  { text: '13:00', value: 26 * 30 * 60 },
  { text: '13:30', value: 27 * 30 * 60 },
  { text: '14:00', value: 28 * 30 * 60 },
  { text: '14:30', value: 29 * 30 * 60 },
  { text: '15:00', value: 30 * 30 * 60 },
  { text: '15:30', value: 31 * 30 * 60 },
  { text: '16:00', value: 32 * 30 * 60 },
  { text: '16:30', value: 33 * 30 * 60 },
  { text: '17:00', value: 34 * 30 * 60 },
  { text: '17:30', value: 35 * 30 * 60 },
  { text: '18:00', value: 36 * 30 * 60 },
  { text: '18:30', value: 37 * 30 * 60 },
  { text: '19:00', value: 38 * 30 * 60 },
  { text: '19:30', value: 39 * 30 * 60 },
  { text: '20:00', value: 40 * 30 * 60 },
  { text: '20:30', value: 41 * 30 * 60 },
  { text: '21:00', value: 42 * 30 * 60 },
  { text: '21:30', value: 43 * 30 * 60 },
  { text: '22:00', value: 44 * 30 * 60 },
  { text: '22:30', value: 45 * 30 * 60 },
  { text: '23:00', value: 46 * 30 * 60 },
  { text: '23:30', value: 47 * 30 * 60 },
  { text: '24:00', value: 48 * 30 * 60 }
]

export default dateUtil
